import { notification } from "antd";
import { myAppointmentActions } from "../appointment";
import { completeAppointmentService, createAppointmentService } from "./services";

export const completeAppointmentActions = (itemId, data) => {
  return async (dispatch) => {
    try {
      dispatch(myAppointmentActions.setIsFetching(true));
      const res = await completeAppointmentService(itemId, data);
      if (res.response?.status === 400) {
        notification.error({ message: res.response?.data?.errors[0] });
        dispatch(myAppointmentActions.setIsFetching(false));
      }
      dispatch(myAppointmentActions.setIsFetching(false));
    } catch (err) {
      console.log(err);
    }
  };
};

export const createAppointmentActions = (data) => {
  return async (dispatch) => {
    try {
      dispatch(myAppointmentActions.setIsFetching(true));
      const res = await createAppointmentService(data);
      if (res?.status === 201) {
        dispatch(myAppointmentActions.setNew(res.cart));
        dispatch(myAppointmentActions.setIsFetching(false));
        return true
      }
      dispatch(myAppointmentActions.setIsFetching(false));
      return false
    } catch (err) {
      console.log(err);
    }
  };
};
